import find from 'lodash/find'
import { Defaults } from 'es-decorators'
import { fractionNumber } from 'helpers/number-helpers'
import { getTemplate } from 'helpers/template-helper'
import { goToCheckout } from 'helpers/redirect-helper'
import { okoPush } from 'helpers/oko-helpers'
import { currentCurrency } from 'init/current-currency'
import { ItemsPopupView } from 'es6/views/popups/items-popup-view'

/**
 * Представление попапа заказа товаров с удаленного склада меньше минимума со страницы корзины
 */
@Defaults({
  events: {
    'click .js-to-checkout': 'goToCheckout',
    'mousedown .js-partner-order-limit-news-link': 'onGoToPartnerOrderLimitNews',
  },
  el: '.js-checkout-remote-popup',

  // необходимый маркер для отправки событий в ОКО
  popupType: 'checkout_popup',
})
export class CartRemotePopupView extends ItemsPopupView {
  /** @inheritDoc */
  run () {
    this.buttonTemplate = getTemplate('#remote-content-template')
    this.itemsTemplate = getTemplate('#popup-items-template')

    this.initPopup()
  }

  /**
   * Действия перед закрытием попапа
   */
  beforePopupClose () {
    this.openMinSumPopup()
  }

  /** @inheritDoc */
  render () {
    const remoteGroup = find(this.collection.cartInfo.groups, { code: 'remote' })
    const remoteSum = remoteGroup.sum
    const templateData = {
      items: this.collection.toJSON(),
      cartSum: remoteSum,
      currencySign: currentCurrency.sign,
      fractionNumber: fractionNumber,
    }
    const markup = this.itemsTemplate(templateData) + this.buttonTemplate(templateData)

    this.$('.js-remote-content-container').html(markup)
    this.open()
  }

  /**
   * Отправляем на оформление заказа товаров с удаленного склада меньше минимума
   */
  goToCheckout () {
    this.beforeButtonAction()

    // отправляем в ОКО необходимые данные о заказе
    okoPush({
      'n': 'custom',
      'category': 'remote_order_popup',
      'custom_str': [this.popupType, 'goto_order'],
    })

    goToCheckout({ is_remote: true })
  }

  /**
   * Переходим на страницу новости об отмене минимальной суммы заказа для товаров партнёров
   */
  onGoToPartnerOrderLimitNews () {
    // Отправляем в ОКО данные об переходе на страницу новости
    okoPush({
      'n': 'custom',
      'category': 'remote_order_popup',
      'custom_str': [this.popupType, 'goto_news'],
    })
  }

  /**
   * Открываем попап
   */
  open () {
    ItemsPopupView.prototype.open.call(this)
    this.okoPushOpen()
  }

  /**
   * Сообщаем ОКО об открытии попапа
   */
  okoPushOpen () {
    okoPush({
      'n': 'custom',
      'category': 'remote_order_popup',
      'custom_str': [this.popupType, 'popup_view'],
    })
  }

  /**
   * Отправляем событие об открытии попапа с минимальной суммой
   */
  openMinSumPopup () {
    this.trigger('show-min-sum-message')
  }
}
